// extracted by mini-css-extract-plugin
export default {"fieldContainer":"Field_fieldContainer__Yif1y","fieldTitle":"Field_fieldTitle__2rFK-","fieldText":"Field_fieldText__fgOxA"};